"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexibleCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _atoms = require("../../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FlexibleCard = ({
  title,
  data,
  width,
  iconName,
  ...rest
}) => {
  return /*#__PURE__*/_react.default.createElement(_style.StyledFlexibleCardDiv, _extends({
    width: width
  }, rest), /*#__PURE__*/_react.default.createElement(_style.StyledFlexibleCardTitle, null, title), data && data.map((cardData, index) => /*#__PURE__*/_react.default.createElement(InnerCard, {
    iconName: iconName,
    width: width,
    key: index,
    title: cardData.title,
    imageUrl: cardData.imageUrl,
    keyValues: cardData.keyValues,
    hideShowNumber: cardData.hideShowNumber
  })));
};

exports.FlexibleCard = FlexibleCard;

const InnerCard = ({
  imageUrl,
  keyValues,
  hideShowNumber,
  width,
  iconName
}) => {
  const [expanded, setExpanded] = (0, _react.useState)(true);
  return /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardDiv, {
    className: "flexible-inner-card",
    width: width
  }, /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardLeftSection, {
    showImage: imageUrl
  }, /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardImg, {
    src: imageUrl
  })), /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardMiddleSection, {
    expanded: expanded
  }, keyValues && Object.keys(keyValues).map((key, index) => keyValues[key] ? /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardInfo, {
    key: index,
    expanded: expanded,
    className: (0, _classnames.default)({
      shouldHideShow: index >= hideShowNumber
    })
  }, /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardInfoKey, null, `${key.charAt(0).toUpperCase().concat(key.substr(1))}: `), /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardInfoValue, null, keyValues[key])) : /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardInfo, {
    key: index,
    expanded: expanded,
    className: (0, _classnames.default)({
      shouldHideShow: index >= hideShowNumber
    })
  }, /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardInfoValue, null, key)))), /*#__PURE__*/_react.default.createElement(_style.StyledInnerCardRightSection, {
    expanded: expanded,
    onClick: () => {
      setExpanded(expanded => !expanded);
    },
    iconName: iconName
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: iconName
  })));
};

FlexibleCard.propTypes = {
  /** Main title of card */
  title: _propTypes.default.string,

  /** Nested cards array. Note:
   * To show something as title only in nested card and not as key value pair
   * then keep value of that key in keyValues as empty. hideShowNumber
   * represents number of lines in card info to show/hide. 0 means all, 1 means
   * skip first and so on etc*/
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    imageUrl: _propTypes.default.string,
    keyValues: _propTypes.default.object,
    hideShowNumber: _propTypes.default.number
  })),

  /** Width of card */
  width: _propTypes.default.string,

  /** Icon name */
  iconName: _propTypes.default.string,

  /** Show/hide card's outer border/outline */
  showBorder: _propTypes.default.bool,

  /** Main card background color */
  background: _propTypes.default.string
};
InnerCard.propTypes = {
  /** Image url for card image */
  imageUrl: _propTypes.default.string,

  /** Key value pairs for card info */
  keyValues: _propTypes.default.object,

  /** Number of lines in card info to show/hide. 0 means all, 1 means skip
   * first and so on */
  hideShowNumber: _propTypes.default.number,

  /** Width of card */
  width: _propTypes.default.string,

  /** Icon name */
  iconName: _propTypes.default.string
};